import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { documentFeatureKey, DocumentState } from 'stores/document/document.reducer';
import { selectFeatureFlags } from 'sharedStores/cms/cms.selectors';
import { selectPolicyHolder } from 'stores/personal/personal.selectors';

export const selectDocumentState: MemoizedSelector<object, DocumentState> =
    createFeatureSelector<DocumentState>(documentFeatureKey);

export const selectIsLoading = createSelector(selectDocumentState, (state) => state.isLoading);

export const selectEmailAddress = createSelector(
    selectDocumentState,
    selectPolicyHolder,
    (state, policyHolderState) => {
        return state.emailAddress && state.emailAddress != ''
            ? state.emailAddress
            : policyHolderState?.person?.emailAddress;
    },
);

/**
 * Show disclosure document popup when:
 * 1. Show disclosure popup feature flag is enabled
 */
export const showDisclosurePopup = createSelector(
    selectFeatureFlags,
    (featureFlags) => featureFlags.showDisclosurePopup,
);
